import {Typography} from "@mui/material";
import {PropsWithChildren} from "react";

export function UserRuleInstructions() {
    return (
        <FooterInstruction>
            <div><strong>Skip</strong> — don't generate a logistics item.</div>
            <div><strong>Try Update</strong> — search for an existing, unreleased logistics item and try to update it. May error if no item is found or restrictions prevent it from being updated.</div>
            <div><strong>Send</strong> — generate a new logistics item, even if one already exists. Use this to override conflicting changes or uneditable items already out there.</div>
        </FooterInstruction>
    );
}

export function UserExistingInstructions() {
    return (
        <FooterInstruction>
            <div style={{paddingLeft: 12, paddingRight: 12, paddingBottom: 12}}>
                <div><strong>Recalculate</strong> — update this logistics item with the new details.</div>
                <div><strong>Leave</strong> — the logistics item is already in progress; leave it wherever it is (no action).</div>
                <div><strong>Return</strong> — queue a request for the driver to pick up the unit from site and bring it back to the warehouse.</div>
            </div>
        </FooterInstruction>
    )
}


export function FooterInstruction(props: PropsWithChildren<{}>) {
    return (
        <div style={{
            marginTop: 8,
            paddingTop: 8,
            borderTop: "1px solid rgba(0,0,0,0.08)",
        }}>
            <Typography component="div" variant="caption" color="text.secondary" sx={{
                fontSize: 11,
                lineHeight: 1.4,
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
            }}>
                {props.children}
            </Typography>
        </div>
    )
}